
/**
 * 發送狀態配置
 */
export const linePushMessageStatusConfig = {
  pending: { label: '待發送', value: 'pending', tagType: 'warning' },
  success: { label: '發送成功', value: 'success', tagType: 'action' },
  failed: { label: '發送失敗', value: 'failed', tagType: 'danger' },
}
